import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=065d77e9&"
import script from "./PromotionDetail.vue?vue&type=script&lang=js&"
export * from "./PromotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports